// ============================================================
// AEII - Utilitaires
// ============================================================

// Hiérarchie des plans d'abonnement
export const PLAN_RANK = {
  gratuit: 0,
  classique: 1,
  premium: 2,
};

// Libellés des plans
export const PLAN_LABELS = {
  gratuit: 'Gratuit',
  classique: 'Classique',
  premium: 'Premium',
};

// Couleurs des badges par plan
export const PLAN_COLORS = {
  gratuit: '#3f7a52',
  classique: '#1d5f8a',
  premium: '#b8862f',
};

// Vérifier si l'utilisateur a accès à un niveau de publication
export const canAccess = (userPlan, requiredLevel) => {
  const u = PLAN_RANK[userPlan] ?? 0;
  const r = PLAN_RANK[requiredLevel] ?? 0;
  return u >= r;
};

// Formater une date en français
export const formatDate = (dateVal) => {
  if (!dateVal) return '';
  const d = new Date(dateVal);
  if (isNaN(d.getTime())) return '';
  return d.toLocaleDateString('fr-FR', {
    day: '2-digit',
    month: 'long',
    year: 'numeric',
  });
};

// Obtenir les initiales d'un nom
export const getInitials = (name) => {
  if (!name) return '?';
  const trimmed = name.trim();
  if (trimmed.length === 0) return '?';
  return trimmed.charAt(0).toUpperCase();
};

// Tronquer un texte
export const truncateText = (text, maxLength = 110) => {
  if (!text) return '';
  if (text.length <= maxLength) return text;
  return text.slice(0, maxLength) + '...';
};

// Générer un slug à partir d'un titre
export const generateSlug = (title) => {
  if (!title) return '';
  return title
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
};

// Grouper un tableau par clé
export const groupBy = (array, key) => {
  return array.reduce((result, item) => {
    const groupKey = item[key] || 'undefined';
    if (!result[groupKey]) {
      result[groupKey] = [];
    }
    result[groupKey].push(item);
    return result;
  }, {});
};

// Trier un tableau par date
export const sortByDate = (array, dateKey = 'publish_date') => {
  return [...array].sort((a, b) => {
    const dateA = new Date(a[dateKey]);
    const dateB = new Date(b[dateKey]);
    return dateB - dateA;
  });
};

// Filtrer par niveau d'accès
export const filterByAccess = (array, userPlan) => {
  return array.filter(item => canAccess(userPlan, item.access_level));
};

// Obtenir le libellé d'un plan
export const getPlanLabel = (plan) => {
  return PLAN_LABELS[plan] || plan;
};

// Obtenir la couleur d'un plan
export const getPlanColor = (plan) => {
  return PLAN_COLORS[plan] || '#667180';
};